import React, { useState, useEffect } from "react";
import { Form, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import { CustomInput, CustomButton } from "components";

import { verifyToken, resetPassword, passwordRecovery } from "api/module/auth";
import { INTERNAL_LINKS } from "enum";

import AuthAlert from "containers/AuthAlert";

import IconLogo from "images/logo-sidebar.svg";

import "./style.scss";

const ResetPasswordPage = ({ match, history }) => {
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(null);
  const [loading2, setLoading2] = useState(false);
  const [showError, setShowError] = useState(false);
  const sendPasswordRecovery = async (data) => {
    setLoading2(true);
    setShowError(false);
    try {
      let response = await passwordRecovery(data.email);
      setLoading2(false);
      console.log(response.status);
      let codes = [200, 201, 204];
      if (codes.indexOf(response.status) > -1) {
        history.push(`/login/passwordRecoverySent`);
      }
    } catch (err) {
      setLoading2(false);
      setShowError(true);
    }
  };
  const spinIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  useEffect(() => {
    execVerifyPassword();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const execVerifyPassword = async () => {
    try {
      let response = await verifyToken(match.params.token);
      setLoading(false);
      if (response.status === 200 || response.status === 201) {
        setIsValid(true);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setIsValid(false);
    }
  };

  const execResetPassword = async (data) => {
    setLoading(true);
    try {
      let response = await resetPassword(match.params.token, data.new_password);
      setLoading(false);
      if (response.status === 200 || response.status === 201) {
        history.push(INTERNAL_LINKS.HOME);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setIsValid(false);
    }
  };

  return (
    <>
      <section className="reset-password-layout">
        <div className="reset-password-layout__form-container">
          <div className="reset-password-layout__logo">
            <img src={IconLogo} alt="login-logo" />
          </div>
          <h3>Reset password</h3>
          {!loading ? (
            isValid ? (
              <Form
                layout="vertical"
                onFinish={(data) => {
                  execResetPassword(data);
                }}
              >
                <Form.Item
                  label="New password"
                  name="new_password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your new password!",
                    },
                  ]}
                >
                  <CustomInput
                    type="password"
                    placeholder="New Password"
                    size="sm"
                  />
                </Form.Item>
                <Form.Item
                  label="Confirm password"
                  name="confirm_password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "The two passwords that you entered do not match!"
                        );
                      },
                    }),
                  ]}
                >
                  <CustomInput
                    type="password"
                    placeholder="Confirm Password"
                    size="sm"
                  />
                </Form.Item>
                <Form.Item>
                  <CustomButton
                    htmlType="submit"
                    text="Reset password"
                    type="primary"
                    size="md"
                  />
                </Form.Item>
              </Form>
            ) : (
              <>
                <AuthAlert
                  title="Sorry!"
                  message={
                    <p>
                      The link to reset your password has expired. Please click on "Get a New Link" below. The link is active for 120 minutes
                    </p>
                  }
                />
                <Form
                  layout="vertical"
                  onFinish={(data) => {
                    sendPasswordRecovery(data);
                  }}
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email!" },
                      { type: "email", message: "Please enter the valid email!" },
                    ]}
                  >
                    <CustomInput size="sm" />
                  </Form.Item>
                  <Form.Item>
                    {loading2 ? (
                      <div className="spinner-container">
                        <Spin indicator={spinIcon}></Spin>
                      </div>
                    ) : (
                      <CustomButton
                        htmlType="submit"
                        text="Get a New Link"
                        type="primary"
                        size="md"
                      />
                    )}
                  </Form.Item>
                </Form>
                {showError && (
                    <>
                      <br />
                      <AuthAlert
                        title="Error"
                        message="Email doesn't match with any user."
                      />
                    </>
                  )}
                <div className="form-container__footer">
                  <br />
                  <Link to={INTERNAL_LINKS.HOME}>Log In</Link>
                </div>
              </>
            )
          ) : (
            <div className="spinner-container">
              <Spin indicator={spinIcon}></Spin>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ResetPasswordPage;